import { useEffect, useRef, type DependencyList, type RefObject } from "react";
import { focusFirstFormField } from "@/utils/form/focusFirstFormField";

/**
 * Returns a ref to attach to a form (or form container). When `enabled`, focuses the
 * first visible input on mount and whenever `deps` change (e.g. after async load).
 */
export function useFormAutoFocus<T extends HTMLElement = HTMLFormElement>(
    enabled = true,
    deps: DependencyList = []
): RefObject<T> {
    const ref = useRef<T>(null);

    useEffect(() => {
        if (!enabled) return;
        const timer = window.setTimeout(() => focusFirstFormField(ref.current), 0);
        return () => window.clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, ...deps]);

    return ref as RefObject<T>;
}
